import axios from 'axios'
import { Offering } from '../Types/offering'

class OfferingClient {
  private baseUrl: string

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  getOfferings = async (): Promise<Offering[]> => {
    const response = await axios({
      method: 'get',
      url: this.baseUrl,
    })
    return response.data
  }
}

const genreClient = new OfferingClient(`${process.env.REACT_APP_API_URL}offerings`)
export default genreClient
